const UserController = require("./userController");

class UserFingerPrint {
  static setup(withoutPageView) {
    const timer = window.setTimeout(() => {
      UserController.getFingerPrint()
        .then((tag) => {
          log(tag, "USER ID:");
          window.gtag("set", { user_id: tag });
        })
        .catch((err) => {
          log(err);
        })
        .finally(() => {
          !withoutPageView && window.gtag("event", "page_view");
          clearTimeout(timer);
        });
    }, 500);
  }
}

module.exports = UserFingerPrint;
